<template>
    <div class="container my-5">
      <!-- Zurück-Button zum Hauptmenü -->
      <button @click="goBack" class="btn btn-secondary mb-3">
        <font-awesome-icon icon="arrow-left" /> Zurück zum Hauptmenü
      </button>
      <h2 class="text-center mb-4">Admin Menü</h2>
      <div class="row justify-content-center">
        <!-- Tile für Auszahlung -->
        <div class="col-12 col-md-6 col-lg-4 mb-4">
          <div class="modern-tile">
            <router-link to="/admin/auszahlung" class="tile-content">
              <font-awesome-icon icon="file-invoice-dollar" class="tile-icon" />
              <span>Auszahlung</span>
            </router-link>
          </div>
        </div>
        <!-- Weitere Admin-Optionen können hier ergänzt werden -->
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'AdminMenu',
    methods: {
      goBack() {
        this.$router.push('/mainmenu');
      },
    },
  };
  </script>
  
  <style scoped>
  .btn {
    margin-bottom: 20px;
    font-size: 16px;
    padding: 10px 20px;
    border-radius: 8px;
  }
  
  .modern-tile {
    background-color: var(--primary-color);
    color: white;
    padding: 20px;
    border-radius: 20px;
    box-shadow: 0 8px 15px rgba(0, 0, 0, 0.15);
    cursor: pointer;
    text-align: center;
    transition: all 0.3s ease;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
    position: relative;
  }
  
  .tile-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-decoration: none;
    color: white;
  }
  
  .tile-content span {
    font-size: 20px;
    font-weight: bold;
    margin-top: 10px;
  }
  
  .tile-icon {
    font-size: 48px;
  }
  
  .modern-tile:hover {
    transform: translateY(-5px);
    box-shadow: 0 12px 20px rgba(0, 0, 0, 0.2);
  }
  </style>
  